import { render, staticRenderFns } from "./CashSettlementsStatements.vue?vue&type=template&id=58af7268&scoped=true&"
import script from "./CashSettlementsStatements.vue?vue&type=script&lang=js&"
export * from "./CashSettlementsStatements.vue?vue&type=script&lang=js&"
import style0 from "./CashSettlementsStatements.vue?vue&type=style&index=0&id=58af7268&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58af7268",
  null
  
)

export default component.exports